import { useEffect } from "react"
import logo from "../../../assets/illustrations/signal-AI.png"
import teeth from "../../../assets/vietnam/landing-page3-bg2.webp"
import "../signal.css"
import { useNavigate } from "react-router-dom"
import { postLogDetails } from "../../../Services/APIs/appDetails"

const GuidePage = () => {
    const navigate = useNavigate();
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket

    useEffect(() => {
        if (!localStorage.getItem("usertpi") || localStorage.getItem("isScanCompleted")) {
            navigate(`/signalai_wohd`)
        } else {
            postLogDetails({ uid, app, payLoad: `Guide page loaded` })
        }
    }, [])

    const moveTCapture = () => {
        // TODO: Implement navigation to next page
        console.log("Moving to next page");
        postLogDetails({ uid, app, payLoad: `Start capture clicked from guide page` })
        navigate("/signalai_wohd/capture");
    }
    return (
        <div className="signal-ai-bg-image h-full w-full flex flex-col">
            <div className="flex-shrink-0">
                <img src={logo} alt="SignalAI Logo" className="w-2/5 mx-auto" />
                <div className="flex flex-col items-center pb-6">
                    <p className=" text-signal-ai-blue text-2xl font-semibold mx-7">သွားကျန်းမာရေးကသင့်ရဲ့ကိုယ်ခန္ဓာကျန်းမာရေးအတွက်အရေးကြီးပါတယ်။</p>
                    <p className="text-signal-ai-blue mx-7 my-3 mt-6"> သင့်ရဲ့သွားတွေကျန်းမာကြံ့ခိုင်နေမှသာ လှပတဲ့အပြုံးတွေနဲ့ နေ့ရက်တိုင်းကိုဖြတ်သန်းနိုင်မှာပါ။</p>
                    <p className="text-signal-ai-blue mx-7 my-3 mt-4"> သွားတွေကသင်နဲ့တစ်သက်လုံးအတူရှိနေမဲ့တန်ဖိုးရှိတဲ့အဖော်မွန်ဖြစ်တာမို့ သင့်သွားကျန်းမာရေးအခြေအနေကို Signal ToothPro Aiနဲ့ စစ်ဆေးလိုက်ပါ။</p>
                    <button onClick={moveTCapture} className="px-4 py-2 bg-signal-ai-secondary text-white rounded mx-auto mt-4 flex justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-camera-icon lucide-camera me-2"><path d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z" /><circle cx="12" cy="13" r="3" /></svg>
                        စကန်ဖတ်ရန်နှိပ်ပါ။</button>
                </div>
            </div>
            <div className="flex-1 flex justify-center items-center overflow-hidden">
                <img src={teeth} alt="Teeth" className="w-full h-full object-cover" />
            </div>
        </div>
    )
}

export default GuidePage